import { styled } from '@linaria/react'

export const ElOfficeSwitcher = styled.div`
  display: flex;
  height: var(--size-8);
  padding: var(--spacing-none) var(--spacing-5);
  align-items: center;
  gap: var(--spacing-4);
  border-bottom: var(--border-default) solid var(--outline-default);
  background: var(--fill-white);
  .el-top-bar-menu-popover {
    top: var(--spacing-8) !important;
  }
`

export const ElCompanyName = styled.span`
  color: var(--text-primary);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-sm);
  letter-spacing: var(--letter-spacing-sm);
`
